import { ErrorBaseData } from '.'

export const authErrors: Record<string, ErrorBaseData> = {
  UserNotFoundException: {
    message: 'Usuário não encontrado',
    description: 'Verifique os dados e tente novamente!',
  },
  PasswordsDoNotMatchException: {
    message: 'Usuário não encontrado',
    description: 'Verifique os dados e tente novamente!',
  },
  InvalidSessionException: {
    message: 'Sessão inválida',
    description: 'Faça login novamente',
  },
  InvalidTokenException: {
    message: 'Sessão inválida',
    description: 'Faça login novamente',
  },
  DeviceCodeNotProvidedException: {
    message: 'Dispositivo não verificado',
    description: 'Faça login novamente e verifique',
  },
  InvalidUserException: {
    message: 'Sessão inválida',
    description: 'Faça login novamente',
  },
  CouldNotRefreshToken: {
    message: 'Sessão expirada',
    description: 'Faça login novamente',
  },
  UserVerificationCodesDoNotMatchException: {
    message: 'Erro no código de verificação',
    description: 'O código de verificação está invalido',
  },
  UserVerificationCodeExpiredException: {
    message: 'Erro no código de verificação',
    description: 'O código de verificação expirou',
  },
  UserVerificationCodeNotFoundException: {
    message: 'Erro no código de verificação',
    description: 'O código de verificação não existe',
  },
  UserVerificationCodeAlreadyVerifiedException: {
    message: 'Erro no código de verificação',
    description: 'Esse código de verificação já foi usado',
  },
}
